import Link from "next/link";

import useSortQueryParam from "hooks/useSortQueryParam";

import Dropdown from "components/botanic/Dropdown";
import DropdownItem from "components/botanic/Dropdown/DropdownItem";

const SORT_TEXT: { [key: string]: string } = {
  priceasc: "Price: Low-High",
  pricedesc: "Price: High-Low",
  review_countdesc: "Review",
  review_ratingdesc: "Rating",
  strain_thcasc: "THC: Low-High",
  strain_thcdesc: "THC: High-Low",
};

const Sort: React.FC = () => {
  const {
    appliedSort,
    utils: { getUrlWithNewSort, getUrlWithoutSort },
  } = useSortQueryParam();

  let selectedItem = "Recommended"; // * Default

  if (appliedSort) {
    const key = Object.keys(appliedSort)[0];
    const value = appliedSort[key];
    selectedItem = SORT_TEXT[`${key}${value}`];
  }

  return (
    <div
      data-testid="sort-dropdown"
      className="flex flex-shrink-0 items-center justify-center text-xs ml-lg"
    >
      Sort by&nbsp;
      <Dropdown className="items-center" selectedItem={selectedItem}>
        <Link href={getUrlWithoutSort()}>
          <DropdownItem key="recommended" className="p-md z-10">
            Recommended
          </DropdownItem>
        </Link>
        <Link href={getUrlWithNewSort("price", "asc")}>
          <DropdownItem
            key="PriceLowToHigh"
            className="p-md z-10 whitespace-nowrap"
          >
            Price: low to high
          </DropdownItem>
        </Link>
        <Link href={getUrlWithNewSort("price", "desc")}>
          <DropdownItem
            key="PriceHighToLow"
            className="p-md z-10 whitespace-nowrap"
          >
            Price: high to low
          </DropdownItem>
        </Link>
        <Link href={getUrlWithNewSort("strain_thc", "asc")}>
          <DropdownItem
            key="THCLowToHigh"
            className="p-md z-10 whitespace-nowrap"
          >
            THC: low to high
          </DropdownItem>
        </Link>
        <Link href={getUrlWithNewSort("strain_thc", "desc")}>
          <DropdownItem
            key="THCHignToLow"
            className="p-md z-10 whitespace-nowrap"
          >
            THC: high to low
          </DropdownItem>
        </Link>
        <Link href={getUrlWithNewSort("review_rating", "desc")}>
          <DropdownItem
            key="ReviewRating"
            className="p-md z-10 whitespace-nowrap"
          >
            Rating
          </DropdownItem>
        </Link>
        <Link href={getUrlWithNewSort("review_count", "desc")}>
          <DropdownItem
            key="ReviewCount"
            className="p-md z-10 whitespace-nowrap"
          >
            Review Count
          </DropdownItem>
        </Link>
      </Dropdown>
    </div>
  );
};

export default Sort;
